module.exports = __webpack_public_path__ + "img/download-app.8956a69.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/download-app.png
// module id = ./assets/img/download-app.png
// module chunks = 25